import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '@fy-web-2/ui-layout';
import { AuthFacade, NavigationFacade } from '@fy-web-2/state-auth';
import { TenantFacade } from '@fy-web-2/state-tenant';

@Component({
  imports: [RouterModule, HeaderComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly auth = inject(AuthFacade);
  private readonly navigation = inject(NavigationFacade);
  private readonly tenant = inject(TenantFacade);

  protected readonly isAuthenticated = this.auth.isAuthenticated;
  protected readonly navItems = this.navigation.navItems;
  protected readonly createItems = this.navigation.createItems;
  protected readonly tenantLogoUrl = this.tenant.logoUrl;
  protected readonly tenantBrandName = this.tenant.brandName;

  protected onLogout(): void {
    void this.auth.logout();
  }

  protected onUploadRateFile(): void {
    // TODO Phase 6.2 — wire the rate-file upload flow once the upload feature
    // exists. For now the header just emits the intent; we acknowledge it so
    // the button is functionally observable.
    console.info('[App] Upload Rate File clicked');
  }
}
